module.exports = __webpack_public_path__ + "images/application/flags@2x-79d314c4.png";